import { css } from "@styled-system/css";

import { theme } from "@skin/v2";

export const styles = {
  footer: {
    left: {
      indicator: ({ isActive }: { isActive: boolean }) =>
        css({
          backgroundColor: isActive
            ? theme.colors.gray[500]
            : theme.colors.gray[100],
          borderRadius: "50%",
          height: "6px",
          width: "6px",
        }),
      root: css({
        alignItems: "center",
        display: "flex",
        flexShrink: 0,
        gap: "8px",
      }),
    },
    right: {
      back: css({
        backgroundColor: "transparent",
        border: "none",
        fontSize: "0.875rem",
        fontWeight: 500,
        padding: "0",
        transition: "color 0.15s ease-in-out",
        "&:disabled": {
          color: theme.colors.gray[100],
        },
        "&:not(:disabled)": {
          color: theme.colors.gray[300],
          cursor: "pointer",
          "&:hover": {
            color: theme.colors.gray[700],
          },
        },
      }),
      continue: css({
        fontSize: "0.875rem",
      }),
      root: css({
        alignItems: "center",
        display: "flex",
        gap: "24px",
        justifyContent: "flex-end",
        width: "100%",
      }),
    },
    root: css({
      alignItems: "center",
      backgroundColor: theme.colors.white,
      borderTop: `1px solid ${theme.colors.gray[100]}`,
      bottom: "0",
      display: "flex",
      gap: "24px",
      justifyContent: "space-between",
      padding: "24px",
      position: "sticky",
      zIndex: 1,
    }),
  },
  root: css({
    ".MuiDialog-paper": {
      borderRadius: "16px",
      gap: "0",
      maxWidth: "768px",
      overflow: "hidden",
      padding: "0",
      "@media (max-width: 640px)": {
        minWidth: "unset",
        overflow: "auto",
      },
    },
  }),
  top: {
    content: {
      body: css({}),
      root: css({
        fontSize: "0.875rem",
        lineHeight: "1.5",
      }),
      timestamp: css({
        color: theme.colors.gray[300],
        fontSize: "0.75rem",
        lineHeight: "1.5",
        marginTop: "24px",
      }),
      title: css({
        fontSize: "1rem",
      }),
    },
    root: css({
      color: theme.colors.gray[500],
      display: "flex",
      flexDirection: "column",
      gap: "24px",
      padding: "24px",
    }),
  },
};
